import React, { FC } from 'react';
import { View } from 'react-native';
import BackButton from '@components/common/backButton';
import { SettingsHeaderProps } from '@components/settings/v2/common/SettingsHeader';

interface HeaderBackButtonProps extends Pick<SettingsHeaderProps, 'backBtnText' | 'backButtonAction'> {}

const HeaderBackButton: FC<HeaderBackButtonProps> = ({ backButtonAction, backBtnText }) => {
  return (
    <View style={{ alignSelf: 'flex-start' }}>
      <BackButton {...{ left: 0, top: 0, padding: 0, text: backBtnText, ...(backButtonAction ? { onPress: backButtonAction } : {}) }} />
    </View>
  );
};

export default HeaderBackButton;
